module.exports = __webpack_public_path__ + "fonts/ChurchwardMarianna-Regular.29c5fafd.woff";